import Hashids from 'hashids/cjs';
const hashids = new Hashids('', 12);

const functions = {
  encode: (value) => hashids.encode(value),
  decode: (str) => hashids.decode(str) && hashids.decode(str).length && hashids.decode(str)[0],
};

export default functions;
